import { Badge, Input } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

export const ChangePasswordModalBody = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  overflow-y: hidden;
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-24);

  ${Input.S.Input} {
    min-width: 370px;
  }
`;

export const FormHeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  ${Badge.S.Badge} {
    cursor: default;
    text-transform: capitalize;
  }
`;
